import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
export const PDF_GENERATION_PENDING = 'NO_PDF_FOUND_ERROR';
export function pdfGenerationPendingAlert() {
  return FloatingAlertStore.addAlert({
    type: 'warning',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.pdfGenerationPendingAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.pdfGenerationPendingAlert.text"
    })
  });
}
export function genericQuoteCreateFailureAlert() {
  return FloatingAlertStore.addAlert({
    type: 'danger',
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.createQuoteSidebar.create.alert.message"
    })
  });
}